import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { HomeComponent } from './home.component';
import { LeaderboardModule } from './leaderboard/leaderboard.module';
import { HomeMaterialModule } from './home-material/home-material.module';
import { ManageClaimsModule } from './manage-claims/manage-claims.module';
import { ManageActivitiesModule } from './manage-activities/manage-activities.module';
import { MessageModule } from '../shared/message/message.module';
import { PrescribedEnablementsComponent } from './prescribed-enablements/prescribed-enablements.component';
import { SellerSalesTabComponent } from './prescribed-enablements/seller-sales-tab/seller-sales-tab.component';
import { SellerActivityTabComponent } from './prescribed-enablements/seller-activity-tab/seller-activity-tab.component';
import { SellerLeaderboardTabComponent } from './prescribed-enablements/seller-leaderboard-tab/seller-leaderboard-tab.component';
import { RewardsModule } from './rewards/rewards.module';
import { AccountDetailsModule } from './account-details/account-details.module';
import { AdminManageClaimsModule } from './admin-manage-claims/admin-manage-claims.module';
import { SharedModule } from '../shared';
import { SellerRewardsDialogComponent } from '../shared';
import { TranslateModule } from '@ngx-translate/core';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { NgxTreeSelectModule } from 'ngx-tree-select';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { MatProgressSpinnerModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { ProgressInfoPopupComponent } from '../shared/components/progress-info-popup/progress-info-popup/progress-info-popup.component';
import { ActivityChallengeDocumentsComponent } from '../shared/components/activity-challenge-documents/activity-challenge-documents/activity-challenge-documents.component';
import { DocumentProofsComponent } from '../shared/components/document-proofs/document-proofs/document-proofs.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DashboardModule } from './dashboard/dashboard.module';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HomeMaterialModule,
    MessageModule,
    NgMultiSelectDropDownModule.forRoot(),
    InfiniteScrollModule,
    SharedModule,
    TranslateModule,
    MatTableModule,
    MatCarouselModule.forRoot(),
    NgxTreeSelectModule.forRoot({
      allowFilter: true,
      filterPlaceholder: 'Search',
      maxVisibleItemCount: 5,
      idField: 'id',
      textField: 'name',
      childrenField: 'children',
      allowParentSelection: false,
      expandMode: 'Selection '
    }),
    SlickCarouselModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    DragDropModule,
    MatMomentDateModule,
    AngularEditorModule,
    ImageCropperModule,
    DashboardModule,
    ManageClaimsModule,
    AdminManageClaimsModule,
    AccountDetailsModule,
    ManageActivitiesModule,
    LeaderboardModule,
    RewardsModule,
  ],
  declarations: [
    HomeComponent,
    PrescribedEnablementsComponent,
    SellerSalesTabComponent,
    SellerActivityTabComponent,
    SellerLeaderboardTabComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  entryComponents: [
    SellerRewardsDialogComponent,
    ProgressInfoPopupComponent,
    ActivityChallengeDocumentsComponent,
    DocumentProofsComponent,
  ],
  providers: []
})
export class HomeModule { }